import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styles/styled-components';
import messages from './messages';
import SVGIcon from 'components/SVGIcon/SVGIcon';
import ArrowRight from './arrowRight.svg';
import { RouteComponentProps, RouteProps, withRouter } from 'react-router-dom';
import ReferrerStep1 from './images/referrerStep1.png';
import ReferrerStep2 from './images/referrerStep2.png';
import ReferrerStep3 from './images/referrerStep3.png';
import ReferrerStep1En from './images/referrerStep1En.png';
import ReferrerStep2En from './images/referrerStep2En.png';
import ReferrerStep3En from './images/referrerStep3En.png';
import RefereeStep1 from './images/refereeStep1.png';
import RefereeStep2 from './images/refereeStep2.png';
import RefereeStep3 from './images/refereeStep3.png';
import RefereeStep1En from './images/refereeStep1En.png';
import RefereeStep2En from './images/refereeStep2En.png';
import RefereeStep3En from './images/refereeStep3En.png';
import Benefit1 from './images/benefit1.png';
import Benefit2 from './images/benefit2.png';
import Benefit3 from './images/benefit3.png';
import DesktopBannerVi from './images/desktopBannerVi.png';
import DesktopBannerEn from './images/desktopBannerEn.png';
import MobileBannerVi from './images/mobileBannerVi.png';
import MobileBannerEn from './images/mobileBannerEn.png';
import faqBg from './images/faqBg.png';

import translations from 'translations';

// --------------- Styled Components ---------------

const maxWidth = 1272;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 103px 0px 0px;
  @media (max-width: 991px) {
    margin: 100px 0px 0px;
  }
`;

// --- Hero Section ---
const HeroSection = styled.section`
  position: relative;
  width: 100%;
  line-height: 0;
`;

const HeroBannerImg = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const FAQBannerImg = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const HeroBannerOverlay = styled.div`
  position: absolute;
  left: 10.35%;
  top: 63%;
  width: 40.1%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  line-height: normal;
  @media (max-width: 991px) {
    left: 50%;
    top: 33%;
    bottom: 5%;
    width: 85%;
    transform: translateX(-50%);
    gap: 12px;
  }
`;

const HeroBannerSubtitle = styled.p`
  font-size: 18px;
  font-weight: 500;
  color: #1f2937;
  margin: 0;
  text-align: center;
  line-height: 26px;
  max-width: 500px;
  @media (max-width: 991px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

const JoinButtonOrange = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #f38a3e;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  width: fit-content;
  transition: background 0.2s;
  font-family: SF Pro Text;
  &:hover {
    background: #e07830;
  }
`;

const JoinButtonGreen = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #43a047;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  width: fit-content;
  transition: background 0.2s;
  font-family: SF Pro Text;
  ${({ isCenter }) => isCenter && 'margin: 0 auto;'}
  &:hover {
    background: #388e3c;
  }
`;

// --- Rewards Section ---

const RewardsSection = styled.section`
  max-width: ${maxWidth}px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 48px;
  @media (max-width: 991px) {
    gap: 24px;
  }
`;

const SectionTitle = styled.h2`
  font-size: 30px;
  font-weight: 700;
  line-height: 40px;
  color: #111827;
  margin: 0;
  padding: 0 16px;
  text-align: center;
  @media (max-width: 991px) {
    font-size: 24px;
    line-height: 32px;
  }
`;

const SectionContainer = styled.div`
  background: ${({ bg }) => (bg ? bg : '#ffffff')};
  padding: 80px 0;
  position: relative;
  @media (max-width: 991px) {
    padding: 40px 0px;
  }
`;

const CardsRow = styled.div`
  display: flex;
  gap: 24px;
  @media (max-width: 991px) {
    overflow: auto;
    scrollbar-width: none; /* Firefox, Safari 18.2+, Chromium 121+ */
    &::-webkit-scrollbar {
      display: none; /* Older Safari and Chromium */
    }
  }
`;

const RewardCard = styled.div`
  flex: 1;
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  &:last-child {
    margin-right: 16px;
  }
  &:first-child {
    margin-left: 16px;
  }
  @media (max-width: 991px) {
    flex-shrink: 0;
    flex-basis: 290px;
  }
`;

const RewardCardImage = styled.div<{ expanded?: boolean }>`
  height: ${({ expanded }) => (expanded ? '210px' : '284px')};
  position: relative;
  transition: height 0.3s ease;
  @media (max-width: 991px) {
    height: ${({ expanded }) => (expanded ? '160px' : '206px')};
  }
`;

const RewardCardImageEl = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0px;
  object-fit: cover;
`;

const RewardCardBody = styled.div<{ expanded?: boolean; color?: string }>`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  background: ${({ expanded, color }) => (expanded && color ? color : '#ffffff')};
  transition: background 0.3s ease;
  @media (max-width: 991px) {
    padding: 16px;
  }
`;

const RewardCardTitle = styled.h3<{ expanded?: boolean }>`
  font-size: 18px;
  font-weight: 600;
  color: ${({ expanded }) => (expanded ? '#ffffff' : '#111827')};
  margin: 0;
  line-height: 26px;
  transition: color 0.3s ease;
  @media (max-width: 991px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

const RewardCardDesc = styled.p<{ expanded?: boolean }>`
  font-size: 16px;
  font-weight: 400;
  color: ${({ expanded }) => (expanded ? '#ffffff' : '#303643')};
  margin: 0;
  line-height: 24px;
  transition: color 0.3s ease;
  @media (max-width: 991px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

const RewardCardChevronRow = styled.div<{ color?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  cursor: pointer;
  background: ${({ color }) => color || 'transparent'};
`;

const RewardCardChevronIcon = styled.span<{ expanded?: boolean }>`
  display: inline-flex;
  align-items: center;
  transform: ${({ expanded }) => (expanded ? 'rotate(0deg)' : 'rotate(180deg)')};
  transition: transform 0.2s;
`;

// --- How To Section ---

const HowToSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 40px;
  max-width: ${maxWidth}px;
  margin: 0 auto;
  @media (max-width: 991px) {
    gap: 24px;
  }
`;

const HowToHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 0 auto;
  align-items: center;
  @media (max-width: 991px) {
    gap: 8px;
  }
`;

const ViewTermsLink = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 16px;
  font-weight: 500;
  color: #3c9041;
  background: none;
  border: none;
  cursor: pointer;
  font-family: 'SF Pro Text';
  padding: 0;
  &:hover {
    text-decoration: underline;
  }
  svg {
    color: #3c9041 !important;
  }
`;

const TabRow = styled.div`
  display: flex;
  @media (min-width: 992px) {
    margin-left: 16px;
  }
`;

const Tab = styled.button<{ active: boolean }>`
  padding: 8px 0 10px;
  font-size: 18px;
  font-weight: ${({ active }: { active: boolean }) => (active ? '600' : '400')};
  color: ${({ active, color }: { active: boolean; color?: string }) => (active ? color || '#43a047' : '#4b5563')};
  background: none;
  border: none;
  border-bottom: ${({ active, color }: { active: boolean; color?: string }) =>
    active ? `3px solid ${color || '#43a047'}` : '1px solid #e5e7eb'};
  cursor: pointer;
  min-width: 175px;
  text-align: center;
  line-height: 24px;
  font-family: 'SF Pro Text';
  @media (max-width: 991px) {
    flex-grow: 1;
    font-size: 16px;
  }
`;

const StepsRow = styled.div`
  display: flex;
  gap: 40px;
  @media (max-width: 991px) {
    gap: 24px;
    overflow: auto;
    scrollbar-width: none; /* Firefox, Safari 18.2+, Chromium 121+ */
    &::-webkit-scrollbar {
      display: none; /* Older Safari and Chromium */
    }
  }
`;

const StepCard = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #f2f2f2;
  border-radius: 16px;
  &:last-child {
    margin-right: 16px;
  }
  &:first-child {
    margin-left: 16px;
  }
  @media (max-width: 991px) {
    flex-shrink: 0;
    flex-basis: 290px;
  }
`;

const StepCardImage = styled.div`
  height: 385px;
  position: relative;
  background: rgb(248 249 249);
  @media (max-width: 991px) {
    height: 288px;
  }
`;

const StepCardImageEl = styled.img`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: -2px;
  object-fit: contain;
`;

const StepCardBody = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StepCardTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  margin: 0;
  line-height: 26px;
  @media (max-width: 991px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

const StepCardDesc = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #303643;
  margin: 0;
  line-height: 24px;
`;

// --- FAQ Section ---

const FaqSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 0 16px;
  max-width: ${maxWidth}px;
  margin: 0 auto;
  align-items: flex-start;
  position: relative;
  z-index: 10;
  @media (max-width: 991px) {
    gap: 24px;
  }
`;

const FaqInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: flex-start;
  width: 100%;
  @media (max-width: 991px) {
    gap: 24px;
  }
`;

const FaqList = styled.div`
  background: #ffffff;
  border-radius: 8px;
  padding: 8px 32px;
  display: flex;
  flex-direction: column;
  max-width: 765px;
  width: 100%;
  @media (max-width: 767px) {
    padding: 0px 16px;
  }
`;

const FaqItem = styled.div`
  border-bottom: 1px solid #e5e7eb;
  padding: 24px 0px;
  &:last-child {
    border-bottom: none;
  }
  @media (max-width: 767px) {
    padding: 16px 0px;
  }
`;

const FaqQuestion = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  cursor: pointer;
`;

const FaqQuestionText = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

const ChevronIcon = styled.span<{ open: boolean }>`
  display: inline-flex;
  align-items: center;
  transform: ${({ open }: { open: boolean }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
  transition: transform 0.2s;
  flex-shrink: 0;
`;

const FaqAnswer = styled.p`
  font-size: 16px;
  color: #374151;
  margin: 12px 0 0;
  line-height: 24px;
  white-space: pre-line;
  @media (max-width: 767px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

// --------------- Component ---------------

const REWARD_CARDS = [
  {
    image: Benefit1,
    title: messages.referrerTitle,
    shortDesc: messages.referrerShortDesc,
    detailDesc: messages.referrerDetailDesc,
    color: '#43a047',
  },
  {
    image: Benefit2,
    title: messages.refereeTitle,
    shortDesc: messages.refereeShortDesc,
    detailDesc: messages.refereeDetailDesc,
    color: '#f38a3e',
  },
  {
    image: Benefit3,
    title: messages.extraGiftTitle,
    shortDesc: messages.extraGiftShortDesc,
    detailDesc: messages.extraGiftDetailDesc,
    color: '#42b2d7',
  },
];

const FAQ_ITEMS = [
  { question: messages.faq1Question, answer: messages.faq1Answer },
  { question: messages.faq2Question, answer: messages.faq2Answer },
  { question: messages.faq3Question, answer: messages.faq3Answer },
  { question: messages.faq4Question, answer: messages.faq4Answer },
  { question: messages.faq5Question, answer: messages.faq5Answer },
  { question: messages.faq6Question, answer: messages.faq6Answer },
];

const REFERRER_STEPS = [
  {
    title: messages.step1Title,
    desc: messages.step1Desc,
    images: {
      vi: ReferrerStep1,
      en: ReferrerStep1En,
    },
  },
  {
    title: messages.step2Title,
    desc: messages.step2Desc,
    images: {
      vi: ReferrerStep2,
      en: ReferrerStep2En,
    },
  },
  {
    title: messages.step3Title,
    desc: messages.step3Desc,
    images: {
      vi: ReferrerStep3,
      en: ReferrerStep3En,
    },
  },
];

const REFEREE_STEPS = [
  {
    title: messages.step1Title,
    desc: messages.refereeStep1Desc,
    images: {
      vi: RefereeStep1,
      en: RefereeStep1En,
    },
  },
  {
    title: messages.step2Title,
    desc: messages.refereeStep2Desc,
    images: {
      vi: RefereeStep2,
      en: RefereeStep2En,
    },
  },
  {
    title: messages.step3Title,
    desc: messages.refereeStep3Desc,
    images: {
      vi: RefereeStep3,
      en: RefereeStep3En,
    },
  },
];

type Props = RouteProps & RouteComponentProps;

const LandingPageReferral: React.FC<Props> = ({ history }) => {
  const [activeTab, setActiveTab] = useState<'referrer' | 'referee'>('referrer');
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [expandedCard, setExpandedCard] = useState<number | null>(null);
  const lang = localStorage.getItem('lang') || 'vi';

  const toggleCard = (index: number) => {
    setExpandedCard(expandedCard === index ? null : index);
  };
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const goToReferral = () => {
    const token = localStorage.getItem('token');
    if (token) {
      window.open('/refer-friends', '_blank');
      return;
    }
    sessionStorage.setItem('fromReferral', 'true');
    history.push('/signin');
  };
  const stepsData = activeTab === 'referrer' ? REFERRER_STEPS : REFEREE_STEPS;
  return (
    <PageWrapper>
      {/* Hero Section */}
      <HeroSection>
        <picture>
          <source media="(max-width: 991px)" srcSet={lang === 'en' ? MobileBannerEn : MobileBannerVi} />
          <HeroBannerImg src={lang === 'en' ? DesktopBannerEn : DesktopBannerVi} alt="hero banner" />
        </picture>
        <HeroBannerOverlay>
          <HeroBannerSubtitle>
            <FormattedMessage {...messages.heroSubtitle} />
          </HeroBannerSubtitle>
          <JoinButtonOrange onClick={goToReferral}>
            <FormattedMessage {...messages.joinNow} />
            <SVGIcon src={ArrowRight} />
          </JoinButtonOrange>
        </HeroBannerOverlay>
      </HeroSection>

      {/* What You'll Get Section */}
      <SectionContainer bg={'#f7f7f8'}>
        <RewardsSection>
          <SectionTitle>
            <FormattedMessage {...messages.rewardsSectionTitle} />
          </SectionTitle>
          <CardsRow>
            {REWARD_CARDS.map((card, index) => {
              const isExpanded = expandedCard === index;
              return (
                <RewardCard key={index}>
                  <RewardCardImage expanded={isExpanded}>
                    <RewardCardImageEl src={card.image} />
                  </RewardCardImage>
                  <RewardCardBody expanded={isExpanded} color={card.color}>
                    <RewardCardTitle expanded={isExpanded}>
                      {isExpanded && index !== REWARD_CARDS?.length - 1 ? (
                        `${translations(card.title)}: ${translations(card.shortDesc)}`
                      ) : (
                        <FormattedMessage {...card.title} />
                      )}
                    </RewardCardTitle>
                    <RewardCardDesc expanded={isExpanded}>
                      <FormattedMessage {...(isExpanded ? card.detailDesc : card.shortDesc)} />
                    </RewardCardDesc>
                  </RewardCardBody>
                  <RewardCardChevronRow color={card.color} onClick={() => toggleCard(index)}>
                    <RewardCardChevronIcon expanded={isExpanded}>
                      <svg width="20" height="20" viewBox="0 0 16 16" fill="none">
                        <path
                          d="M4 6L8 10L12 6"
                          stroke="#ffffff"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </RewardCardChevronIcon>
                  </RewardCardChevronRow>
                </RewardCard>
              );
            })}
          </CardsRow>
        </RewardsSection>
      </SectionContainer>

      {/* How To Section */}
      <SectionContainer>
        <HowToSection>
          <HowToHeader>
            <SectionTitle>
              <FormattedMessage {...messages.howToTitle} />
            </SectionTitle>
            <ViewTermsLink
              onClick={() =>
                window.open(
                  'https://image-handler-prod.s3.ap-southeast-1.amazonaws.com/supplier/654/FILE/Copy+of+Term+%26+Condition+Referral+3.0.pdf',
                  '_blank',
                )
              }
            >
              <FormattedMessage {...messages.viewTerms} />
              <SVGIcon src={ArrowRight} color="#3c9041" renderAsImg={false} />
            </ViewTermsLink>
          </HowToHeader>

          <TabRow>
            <Tab active={activeTab === 'referrer'} onClick={() => setActiveTab('referrer')}>
              <FormattedMessage {...messages.tabReferrer} />
            </Tab>
            <Tab active={activeTab === 'referee'} color="#E56910" onClick={() => setActiveTab('referee')}>
              <FormattedMessage {...messages.tabReferee} />
            </Tab>
          </TabRow>

          <StepsRow>
            {stepsData.map((step, index) => (
              <StepCard key={index}>
                <StepCardImage>
                  <StepCardImageEl src={step?.images[lang]} />
                </StepCardImage>
                <StepCardBody>
                  <StepCardTitle>
                    <FormattedMessage {...step.title} />
                  </StepCardTitle>
                  <StepCardDesc>
                    <FormattedMessage {...step.desc} />
                  </StepCardDesc>
                </StepCardBody>
              </StepCard>
            ))}
          </StepsRow>

          <JoinButtonGreen isCenter onClick={goToReferral}>
            <FormattedMessage {...messages.joinNow} />
            <SVGIcon src={ArrowRight} />
          </JoinButtonGreen>
        </HowToSection>
      </SectionContainer>

      {/* FAQ Section */}
      <SectionContainer bg={'#f7f7f8'}>
        <picture>
          <source media="(max-width: 991px)" srcSet={faqBg} />
          <FAQBannerImg src={faqBg} alt="hero banner" />
        </picture>
        <FaqSection>
          <FaqInner>
            <SectionTitle>
              <FormattedMessage {...messages.faqTitle} />
            </SectionTitle>
            <FaqList>
              {FAQ_ITEMS.map(({ question, answer }, index) => (
                <FaqItem key={index} onClick={() => toggleFaq(index)}>
                  <FaqQuestion>
                    <FaqQuestionText>
                      <FormattedMessage {...question} />
                    </FaqQuestionText>
                    <ChevronIcon open={openFaq === index}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path
                          d="M9.96504 5.27017C10.2265 5.27021 10.4797 5.36837 10.6584 5.54442L18.7956 13.5734C18.8211 13.5985 18.8342 13.6339 18.8322 13.6694C18.8301 13.7049 18.8132 13.7385 18.785 13.7606L17.5774 14.7021C17.5397 14.7314 17.4896 14.7364 17.448 14.7184L17.4097 14.6924L9.96423 7.34781L2.52038 14.6924C2.48646 14.7256 2.43766 14.7364 2.39424 14.7233L2.35274 14.7021L1.14587 13.7606C1.11755 13.7385 1.09997 13.705 1.09785 13.6694C1.09587 13.6339 1.10902 13.5985 1.13447 13.5734L9.27169 5.54442C9.45034 5.36836 9.70359 5.27021 9.96504 5.27017Z"
                          fill="white"
                        />
                      </svg>
                    </ChevronIcon>
                  </FaqQuestion>
                  {openFaq === index && (
                    <FaqAnswer dangerouslySetInnerHTML={{ __html: translations(answer) }}>
                      {/* <FormattedMessage {...answer} /> */}
                    </FaqAnswer>
                  )}
                </FaqItem>
              ))}
            </FaqList>
          </FaqInner>
          <JoinButtonGreen onClick={goToReferral}>
            <FormattedMessage {...messages.joinNow} />
            <SVGIcon src={ArrowRight} />
          </JoinButtonGreen>
        </FaqSection>
      </SectionContainer>
    </PageWrapper>
  );
};

export default withRouter(LandingPageReferral);
